module.exports = __webpack_public_path__ + "static/media/ramen-dark-animated.90856c58.gif";